import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

import {
  Botao,
  Carregando,
  ErroContainerLayout,
  ErroLayoutContainer,
  formatarCpf,
  FormUnform,
  InputUnform,
  LayoutAuth
} from 'src/componentes'
import { RotasApp } from 'src/rotas'
import { Api } from 'src/servicos'
import { UsuarioAuth } from 'src/servicos/api/tipos'

import { ResumoUsuario, Form } from './styles'

const PaginaPrimeiroAcesso: React.FC = () => {
  const [carregando, definirCarregando] = useState(false)
  const [pronto, definirPronto] = useState(false)
  const [dadosUsuario, definirDadosUsuario] = useState({} as UsuarioAuth)
  const [idUsuario, definirIdUsuario] = useState(null)
  const [token, definirToken] = useState(null)

  const { erro, definirErro } = ErroLayoutContainer.useContainer()
  const history = useHistory()

  const carregarUsuario = async () => {
    try {
      definirPronto(true)
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)

      const id = urlParams.get('id')
      const novoToken = urlParams.get('token')
      definirIdUsuario(id)
      definirToken(novoToken)

      if (!id || !novoToken) {
        throw new Error(
          'Página não encontrada, verifique se você copiou todo o caminho de primeiro acesso.'
        )
      }

      const usuario = await Api.RequisitarUsuarioAuth(id)

      definirDadosUsuario(usuario)
    } catch (error) {
      definirErro({
        mensagens: error.message
      })
    } finally {
      definirPronto(true)
    }
  }

  const acaoSucesso = async ({
    senha,
    repetirSenha
  }: {
    senha: string
    repetirSenha: string
  }): Promise<void> => {
    try {
      definirCarregando(true)
      if (senha === repetirSenha) {
        const sucesso = await Api.PrimeiroAcesso(idUsuario, senha, token)

        if (sucesso) {
          history.push(RotasApp.Home)
          toast('Sua senha foi definida com sucesso!', { type: 'success' })
        }
      }
    } finally {
      definirCarregando(false)
    }
  }

  useEffect(() => {
    carregarUsuario()
  }, [])

  return (
    <LayoutAuth>
      {pronto && !erro ? (
        <Form>
          <h1>Primeiro Acesso</h1>
          <ResumoUsuario>
            <p>Nome: {dadosUsuario.nome}</p>
            {!!dadosUsuario.cpf && <p>CPF: {formatarCpf(dadosUsuario.cpf)}</p>}
            <p>E-mail: {dadosUsuario.email}</p>
          </ResumoUsuario>
          <FormUnform acaoSucesso={acaoSucesso}>
            <InputUnform
              type="password"
              id="ipt_senha"
              label="Informe sua Nova Senha"
              name="senha"
              autoComplete="off"
              maxWidthInput="100%"
              obrigatorio
            />
            <InputUnform
              type="password"
              id="ipt_repetir_senha"
              label="Confirme sua Nova Senha"
              name="repetirSenha"
              autoComplete="off"
              maxWidthInput="100%"
              obrigatorio
              semValidacaoSenha
            />
            <Botao
              type="submit"
              id="btn-enviar"
              texto="Definir Senha"
              carregando={carregando}
            />
          </FormUnform>
        </Form>
      ) : !pronto && !erro ? (
        <Carregando texto="Carregando ..." />
      ) : (
        <ErroContainerLayout />
      )}
    </LayoutAuth>
  )
}

export const PrimeiroAcesso: React.FC = props => {
  return (
    <ErroLayoutContainer.Provider>
      <PaginaPrimeiroAcesso {...props} />
    </ErroLayoutContainer.Provider>
  )
}
